import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './Dashboard.css';

interface DashboardStats {
  operadores: { total: number; aprobados: number; pendientes: number };
  vehiculos: { total: number; activos: number };
  documentos: { total: number; vencidos: number; por_vencer: number };
  viajes: { total: number; en_ruta: number; programados: number };
}

const Dashboard: React.FC = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      // Cargar estadísticas desde diferentes endpoints
      const [operadores, vehiculos, documentos, viajes] = await Promise.all([
        api.get('/operadores?limit=1').catch(() => ({ data: { pagination: { total: 0 } } })),
        api.get('/vehiculos?limit=1').catch(() => ({ data: { pagination: { total: 0 } } })),
        api.get('/documentos/proximos-vencer?dias=30').catch(() => ({ data: { data: [] } })),
        api.get('/viajes?limit=1').catch(() => ({ data: { pagination: { total: 0 } } })),
      ]);

      setStats({
        operadores: {
          total: operadores.data.pagination?.total || 0,
          aprobados: 0,
          pendientes: 0,
        },
        vehiculos: {
          total: vehiculos.data.pagination?.total || 0,
          activos: 0,
        },
        documentos: {
          total: 0,
          vencidos: documentos.data.data?.filter((d: any) => d.estado === 'vencido').length || 0,
          por_vencer: documentos.data.data?.length || 0,
        },
        viajes: {
          total: viajes.data.pagination?.total || 0,
          en_ruta: 0,
          programados: 0,
        },
      });
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando estadísticas...</div>;
  }

  return (
    <div className="dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">👤</div>
          <div className="stat-content">
            <h3>Operadores</h3>
            <p className="stat-number">{stats?.operadores.total || 0}</p>
            <p className="stat-label">Total registrados</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🚛</div>
          <div className="stat-content">
            <h3>Vehículos</h3>
            <p className="stat-number">{stats?.vehiculos.total || 0}</p>
            <p className="stat-label">Total registrados</p>
          </div>
        </div>

        <div className="stat-card warning">
          <div className="stat-icon">⚠️</div>
          <div className="stat-content">
            <h3>Documentos</h3>
            <p className="stat-number">{stats?.documentos.por_vencer || 0}</p>
            <p className="stat-label">Por vencer (30 días)</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🗺️</div>
          <div className="stat-content">
            <h3>Viajes</h3>
            <p className="stat-number">{stats?.viajes.total || 0}</p>
            <p className="stat-label">Total registrados</p>
          </div>
        </div>
      </div>

      <div className="dashboard-actions">
        <h2>Accesos Rápidos</h2>
        <div className="action-buttons">
          <a href="/operadores" className="action-button">
            <span className="action-icon">➕</span>
            <span>Nuevo Operador</span>
          </a>
          <a href="/vehiculos" className="action-button">
            <span className="action-icon">➕</span>
            <span>Nuevo Vehículo</span>
          </a>
          <a href="/viajes" className="action-button">
            <span className="action-icon">➕</span>
            <span>Nuevo Viaje</span>
          </a>
          <a href="/documentos" className="action-button">
            <span className="action-icon">📄</span>
            <span>Ver Documentos</span>
          </a>
          <a href="/postulaciones" className="action-button">
            <span className="action-icon">📝</span>
            <span>Gestionar Postulaciones</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

